import { HelmetProvider } from '@psl/appComponents/seo/helmet';
import { memo, ReactNode } from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';

export const AppRoot = memo(({ children }: { children?: ReactNode }) => {
  return (
    <GestureHandlerRootView
      css={`
        flex: 1;
        background-color: #000;
      `}
    >
      <HelmetProvider>{children}</HelmetProvider>
    </GestureHandlerRootView>
  );
});
